export var DEPLOY_DATE = new Date('2026-09-30T10:41:53+0000');
